module.exports = __webpack_public_path__ + "img/process.c578b375.png";